import {useSelector} from 'react-redux'

export const useCache = ({tableName}) => {
	return useSelector(state => state.components.advancedTable[tableName]) || {}
}
